import React from "react";
import {
  Layers,
  Home,
  FolderOpenDot,
  Users,
  LibraryBig,
  Library,
  SquareDashed,
  LayoutPanelTop,
} from "lucide-react";

export const MAIN_SIDEBAR_MENU = [
  {
    title: "Home",
    icon: Home,
    path: "/",
  },
  {
    title: "Templates",
    icon: Layers,
    path: "/templates",
  },
  {
    title: "Sets",
    icon: LayoutPanelTop,
    path: "/sets",
  },
  {
    title: "Print Locations",
    icon: SquareDashed,
    path: "/print-locations",
  },
  {
    title: "Categories",
    icon: LibraryBig,
    path: "/categories",
  },
  {
    title: "Subcategories",
    icon: Library,
    path: "/subcategories",
  },
  {
    title: "Projects",
    icon: FolderOpenDot,
    path: "/projects",
  },
  {
    title: "Users",
    icon: Users,
    path: "/users",
  },
];
